import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Power, Shield } from 'lucide-react';
import EtatGeneral from '../EtatGeneral';
import ShareViewerButton from './ShareViewerButton';

const DashboardHeader = ({ token, stats, isChef, onToggleEvent }) => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const [elapsed, setElapsed] = useState('');

    useEffect(() => {
        const tick = setInterval(() => {
            setCurrentTime(new Date());
            if (stats?.pcs_activation_time && stats?.event_active !== false) {
                const start = new Date(stats.pcs_activation_time);
                const now = new Date();
                const diff = Math.max(0, now - start);
                const h = Math.floor(diff / 3600000);
                const m = Math.floor((diff % 3600000) / 60000);
                const s = Math.floor((diff % 60000) / 1000);
                setElapsed(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
            }
        }, 1000);
        return () => clearInterval(tick);
    }, [stats?.pcs_activation_time, stats?.event_active]);

    return (
        <div className="page-header">
            <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                    {/* Current Time */}
                    <div className="glass-panel px-5 py-3 rounded-lg" data-testid="current-time">
                        <p className="text-[10px] text-zinc-500 uppercase tracking-wider">Heure actuelle</p>
                        <p className="font-mono text-4xl text-white font-bold leading-tight">
                            {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                        </p>
                        <p className="text-xs text-zinc-500 mt-0.5">{currentTime.toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })}</p>
                    </div>
                    {/* PCS Chrono */}
                    {stats?.pcs_activation_time && stats?.event_active !== false && (
                        <div className="glass-panel px-5 py-3 rounded-lg border border-red-500/30" data-testid="pcs-chrono">
                            <p className="text-[10px] text-red-400 uppercase tracking-wider flex items-center gap-1">
                                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse inline-block"></span> PCS actif
                            </p>
                            <p className="font-mono text-4xl text-red-400 font-bold leading-tight">{elapsed || '00:00:00'}</p>
                            <p className="text-xs text-zinc-500 mt-0.5">depuis {new Date(stats.pcs_activation_time).toLocaleString('fr-FR', {day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'})}</p>
                        </div>
                    )}
                </div>
                {/* Etat General - centre (Chef de Dispositif uniquement) */}
                <div className="flex-1 flex justify-center">
                    {isChef && <EtatGeneral token={token} />}
                </div>
                <div className="flex items-center gap-3">
                    {isChef && <ShareViewerButton token={token} />}
                    {isChef && (
                        <Button
                            onClick={onToggleEvent}
                            className={`px-5 py-6 text-base font-semibold ${stats?.event_active !== false ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'}`}
                            data-testid="pcs-toggle-btn"
                        >
                            <Power className="w-5 h-5 mr-2" />
                            {stats?.event_active !== false ? 'Cloturer PCS' : 'Activer PCS'}
                        </Button>
                    )}
                </div>
            </div>
            {stats?.event_active === false && (
                <div className="mt-3 p-3 bg-amber-500/10 border border-amber-500/30 rounded-lg flex items-center gap-2" data-testid="pcs-inactive-banner">
                    <Shield className="w-5 h-5 text-amber-400" />
                    <span className="text-amber-400 font-medium">Evenement PCS cloture</span>
                </div>
            )}
        </div>
    );
};

export default DashboardHeader;
